export interface Room {
  id: string;
  businessId: string;
  name: string;
  description: string;
  pricePerNight: number;
  capacity: number;
  bedType: string;
  images: string[];
  amenities: string[];
  available: boolean;
  status: string;
}

export interface Booking {
  id: string;
  roomId: string;
  businessId: string;
  userId: string;
  checkIn: string;
  checkOut: string;
  nights: number;
  guests: number;
  totalPrice: number;
  customerName: string;
  customerPhone: string;
  status: string;
  paymentStatus: string;
  createdAt: string;
  roomName?: string;
}

const PLACEHOLDER_IMAGE =
  'https://readdy.ai/api/search-image?query=Elegant%20hotel%20room%20interior%20with%20comfortable%20bed%2C%20warm%20ambient%20lighting%2C%20clean%20modern%20African%20luxury%20decor%2C%20soft%20neutral%20tones%2C%20professional%20hospitality%20photography&width=800&height=500&seq=room-placeholder-01&orientation=landscape';

interface RoomDbRow {
  id: string;
  business_id?: string | null;
  name?: string | null;
  description?: string | null;
  price_per_night?: number | null;
  capacity?: number | null;
  bed_type?: string | null;
  images?: string[] | null;
  amenities?: string[] | null;
  available?: boolean | null;
  status?: string | null;
}

export function mapDbRoom(row: RoomDbRow): Room {
  const images =
    Array.isArray(row.images) && row.images.length > 0 ? row.images : [PLACEHOLDER_IMAGE];
  return {
    id: row.id,
    businessId: row.business_id || '',
    name: row.name || 'Chambre',
    description: row.description || '',
    pricePerNight: Number(row.price_per_night) || 0,
    capacity: Number(row.capacity) || 1,
    bedType: row.bed_type || '',
    images,
    amenities: Array.isArray(row.amenities) ? row.amenities : [],
    available: Boolean(row.available),
    status: row.status || 'active',
  };
}

export function formatPrice(price: number): string {
  return `${Number(price || 0).toLocaleString('fr-FR')} FCFA`;
}

export function formatDate(iso: string): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' });
}

export const BED_TYPES = [
  'Lit simple',
  'Lit double',
  'Lits jumeaux',
  'Lit queen-size',
  'Lit king-size',
  'Lits superposés',
];

export const ROOM_AMENITIES = [
  'Climatisation',
  'Wi-Fi gratuit',
  'Télévision',
  'Salle de bain privée',
  'Balcon',
  'Vue sur mer',
  'Minibar',
  'Coffre-fort',
  'Petit-déjeuner inclus',
  'Room service',
  'Bureau',
  'Machine à café',
];